<script>
  // display TOC for all newsletters 
  // in list (eg virus) or array of newsletters in property "listQuery"
  // note that following, pressPledge and other special converted to array BEFORE here
  // also this does not care about state (store.js) 

  import { Collection } from "sveltefire";
  import CardTOC from './CardTOC.svelte';
  export let listQuery; //either an array of pubs or listId where listId can be listType:xxxx

  console.log("@List listQuery="+listQuery);
  let listType="listsArray"; //house and recommend are different types of lists
  let currentQuery=listQuery; //don't want to modify listQuery, query on currentQuery
  let seperator="--"; //see SubNav.svelte
  $: if (typeof listQuery === 'string'){
    console.log("@List listQuery="+listQuery);
    currentQuery=listQuery; //because reactive need to add assignment
    listType="listsArray";
    if (listQuery.includes(seperator)){
      if (listQuery.split(seperator)[0] == "house"){
        listType="housesArray"
      };
      if (listQuery.split(seperator)[0] == "recommend"){
        listType="recommendsArray"
      };
      currentQuery=listQuery.split(seperator)[1];
    }
  }
  console.log("@List currentQuery="+currentQuery);

  // expand first toc, contract rest expand|contract
  const expandToc = function(x){
    if (x==0) {return "expand"}
    return "contract"
  }

  const sortedPublishers = function(publishers){
    return publishers.sort((a, b) => b.toc[0].split("||")[0].split("_")[1] - a.toc[0].split("||")[0].split("_")[1]);
  }
  import firebase from "firebase/app";
  // console.log("@List.svelte listId="+JSON.stringify($listId))
</script>

<div class="lists">
  <!-- <p>@List listquery={listQuery} currentQuery={currentQuery}</p> -->
  {#if Array.isArray(currentQuery)}
    <!-- <h2>Array</h2> -->
    <Collection
      path={'publishers'} 
      query={ref => ref.where(firebase.firestore.FieldPath.documentId(), "in", listQuery)}
      let:data={publishers} let:ref={publishersRef} log>
      {#if !publishers.length}
          No publishers yet @Lists... "listQuery"
          <p>listQuery= {listQuery}</p>
      {/if}
      
      {#if !publishers.isPrivate}
        <!-- <div id="{$listId}" class="title">{$listTitle}</div> -->
        {#each sortedPublishers(publishers) as publisher, i}
          <CardTOC toc={publisher.toc} expand="{expandToc(i)}"
          isPaidVersion={publisher.isPaidVersion}>
          </CardTOC>
        {/each}
      {/if}
      <span slot="loading">Loading @List</span>
    </Collection>
  {/if} 

  {#if !Array.isArray(currentQuery)}   <!--  list not an array -->
    <!-- <h2>listQuery</h2> means it is a list of some sort -->
    <Collection
      path={'publishers'} query={ref => ref.where(listType, "array-contains", currentQuery)}
      let:data={publishers} let:ref={publishersRef} log once>
      {#if !publishers.length}
          No publishers yet @Lists... "listsArray" 
          <p>currentQuery= {currentQuery}</p>
      {/if}
      
      {#if !publishers.isPrivate}
        <!-- <div class="title">{$listTitle}</div>
        <div class="description">{$listDescription}</div> -->
        {#each sortedPublishers(publishers) as publisher, i}
          <CardTOC toc={publisher.toc} expand="{expandToc(i)}"
          isPaidVersion={publisher.isPaidVersion}></CardTOC>
        {/each}
      {/if}
      <span slot="loading">Loading @List.svelte array-contains ...</span>
    </Collection>
  {/if} 
</div>

<style>
  .lists {text-align: left;}
  .description, .title {font-weight: bold;}
  .title {font-size: 0.5rem;}
</style>